import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function OfferImpactSection() {
  return <section className="py-20 bg-[#F2E8DA]/50 backdrop-blur-[2px]" data-id="element-315">
      <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-316">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-317">
          {/* Glowing framed card */}
          <div className="relative rounded-2xl border-3 border-terracotta/40 bg-white p-8 md:p-12 shadow-xl animate-border-glow overflow-hidden" data-id="element-318">
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-terracotta rounded-tl-2xl" data-id="element-319"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-terracotta rounded-tr-2xl" data-id="element-320"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-terracotta rounded-bl-2xl" data-id="element-321"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-terracotta rounded-br-2xl" data-id="element-322"></div>

            {/* Top ribbon */}
            <div className="absolute -top-px left-1/2 -translate-x-1/2 bg-terracotta text-white px-6 py-1.5 rounded-b-lg font-bold text-xs uppercase tracking-widest shadow-md" data-id="element-323">
              ⚡ Tiempo limitado ⚡
            </div>

            <div className="flex justify-center mb-6 mt-4" data-id="element-324">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-gold-soft to-terracotta/80 flex items-center justify-center shadow-lg" data-id="element-325">
                <SparklesIcon className="w-7 h-7 text-white" data-id="element-326" />
              </div>
            </div>

            <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-dark mb-6" data-id="element-327">
              Oferta especial por tiempo{' '}
              <span className="uppercase font-black" data-id="element-328">LIMITADO</span>
            </h2>

            <p className="text-lg text-text-medium mb-4" data-id="element-329">
              El valor original de estos bonos es de{' '}
              <span className="font-semibold text-text-dark" data-id="element-330">$49 cada uno</span>
              .
            </p>

            <p className="text-xl font-bold text-terracotta" data-id="element-331">
              Pero hoy puedes acceder a ellos por un precio especial.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}